import { FunctionComponent } from "react";

export const MfsLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/mfs.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Mobilize FS"
    />
  );
};
